import { jsonApiClient } from '@/httpConfig/config/axios';

export const walletsService = {
  list: () => jsonApiClient.get('/wallets'),
  get: (id) => jsonApiClient.get(`/wallets/${id}`),
};
